import React, { useEffect, useRef } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { Form, Formik } from 'formik';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import validationSchema from './AdminsSearch.schema';
import { FormInputField, FormSelectField } from '../../common/components/formFields';
import { constantToSelect } from '../../common/helpers';
import { AdminRoleName } from '../../constants/AdminRole';
import ComponentCard from '../../common/components/cards/ComponentCard';

const initialValues = {
  firstName: '',
  lastName: '',
  email: '',
  role: '',
};

const adminRoles = constantToSelect(AdminRoleName);

function AdminsSearch({ onSearch }) {
  const formRef = useRef();
  const previousSearchState = useSelector((state) => state.admins.get('searchState'));

  useEffect(() => {
    if (previousSearchState?.searchParams) {
      formRef.current.setValues(previousSearchState?.searchParams);
    }
  }, [previousSearchState]);

  const handleClear = (resetForm, submitForm) => {
    resetForm();
    submitForm();
  };

  return (
    <Col md="12">
      <ComponentCard title="Search Admin" isCollapsible>
        <Formik
          innerRef={formRef}
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSearch}
          validateOnBlur
        >
          {({ resetForm, submitForm }) => (
            <Form noValidate>
              <Row>
                <Col md="4">
                  <FormInputField name="firstName" label="First Name" />
                </Col>
                <Col md="4">
                  <FormInputField name="lastName" label="Last Name" />
                </Col>
                <Col md="4">
                  <FormInputField name="email" label="Email Address" type="email" />
                </Col>
                <Col md="4">
                  <FormSelectField name="role" label="Role" options={adminRoles} />
                </Col>
              </Row>
              <Row>
                <Col md="12">
                  <Button
                    className="mt-4 float-end ms-2 rounded-pill btn-primary"
                    type="submit"
                  >
                    Search
                  </Button>
                  <Button
                    className="mt-4 float-end rounded-pill btn-soft-primary"
                    type="button"
                    onClick={() => handleClear(resetForm, submitForm)}
                  >
                    Clear
                  </Button>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
      </ComponentCard>
    </Col>
  );
}

AdminsSearch.propTypes = {
  onSearch: PropTypes.func.isRequired,
};
export default AdminsSearch;
